import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQueryOptions } from "@/api/queries/session";
import { AppShell } from "@/app/layouts/app-shell";

/**
 * Every app route lives under this guard. GET /v1/me decides: no session → /login with the
 * original destination preserved.
 */
export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions());
    if (!me) throw redirect({ to: "/login", search: { redirect: location.href } });
    return { me };
  },
  component: AppShell,
});
